import React, { memo, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './index.module.scss'

import { LockFilled } from '@ant-design/icons'
import CopyRight from '@/views/Layout/components/CopyRight'
interface IChildProps {
  children: ReactNode
}
const NoSidebar = memo<IChildProps>(props => {
  const { children } = props
  const { t } = useTranslation()
  return (
    <div className={styles.layout}>
      <div className={styles.container}>
        <header>
          <span>{t('other.confirmWebsit')}</span>
          <div className={styles.url}>
            <LockFilled style={{ fontSize: '12px', color: '#12b89a' }} className={styles.lock} />
            <span>{window.location.origin}</span>
          </div>
        </header>
        <div className={styles.content}> {children}</div>
      </div>
      <CopyRight />
    </div>
  )
})

export default NoSidebar
